import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Alert, FullPageWrapper } from 'shared/ui'
import { LINK_RINGLESS_VOICEMAIL_BEST_PRACTICES } from 'shared/constants/links'
import { useTriggerDetailContext } from 'widgets/TriggerDetail/context/triggerDetailContext'
import { TriggerDetailHeader } from 'widgets/TriggerDetail/ui/TriggerDetailHeader/TriggerDetailHeader'
import { ContactStatisticsSearch } from 'widgets/TriggerDetail/ui/ContactStatisticsSearch/ContactStatisticsSearch'
import { ContactStatisticsFilter } from 'widgets/TriggerDetail/ui/ContactStatisticsFilter/ContactStatisticsFilter'
import { ContactStatisticsTable } from 'widgets/TriggerDetail/ui/ContactStatisticsTable/ContactStatisticsTable'
import { ContactsDetails } from 'widgets/ContactsDetails'

export const TriggerDetailContent = observer(() => {
  const store = useTriggerDetailContext()

  useEffect(() => {
    return () => {
      store.reset()
    }
  }, [])

  return (
    <FullPageWrapper>
      <TriggerDetailHeader />
      {store.trigger.type === 'ringless' && (
        <div style={{ margin: '0 20px 16px 20px' }}>
          <Alert
            item={{
              type: 'infoLight',
              title: 'Ringless voicemails typically reach 60–85% of contacts',
            }}
            rightActions={[
              {
                variant: 'link',
                type: 'primary',
                text: 'Learn why delivery varies',
                link: LINK_RINGLESS_VOICEMAIL_BEST_PRACTICES,
              },
            ]}
          />
        </div>
      )}
      <ContactStatisticsFilter />
      <ContactStatisticsSearch />
      <ContactStatisticsTable />
      {store.contactsDetailsStore && <ContactsDetails store={store.contactsDetailsStore} />}
    </FullPageWrapper>
  )
})
